<ion-header>
  <ion-toolbar>
    <ion-title>{{"PUZZLE.solution_word_dialog.title" | translate}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <ion-grid>
    <ion-row>
      <ion-list *ngIf="isSayingDialog">
        <ion-item lines="none">
          <ion-text>{{"PUZZLE.solution_word_dialog.saying_text" | translate}}</ion-text>
        </ion-item>
      </ion-list>
      <ion-list *ngIf="!isSayingDialog">
        <ion-item lines="none" *ngIf="!sweepstake">
          <ion-text>{{"PUZZLE.solution_word_dialog.text" | translate}}</ion-text>
        </ion-item>
        <ion-item lines="none" *ngIf="sweepstake && winType === 'solution-word'">
          <ion-text>{{"PUZZLE.solution_word_dialog.sweepstake.solution_word" | translate}}</ion-text>
        </ion-item>
        <ion-item lines="none" *ngIf="sweepstake && winType === 'full-puzzle'">
          <ion-text>{{"PUZZLE.solution_word_dialog.sweepstake.full_puzzle" | translate}}</ion-text>
        </ion-item>
      </ion-list>
    </ion-row>
    <ion-row class="puzzle-modal-grow" *ngIf="!isSayingDialog">
      <ion-list *ngIf="solutionWord || solutionOriginal">
        <ion-item lines="none">
          <ion-text>{{"PUZZLE.solution_word_dialog.sweepstake_intro" | translate }}</ion-text>
        </ion-item>
        <ion-item lines="none">
          <lib-app-puzzle-solution-word-animation class="solution-word" [solutionWord]="solutionWord" [solutionOriginal]="solutionOriginal"></lib-app-puzzle-solution-word-animation>
        </ion-item>
      </ion-list>
    </ion-row>
    <ion-row class="puzzle-modal-grow" *ngIf="isSayingDialog">
      <ion-list *ngIf="saying || sayingOriginal">
        <ion-item lines="none">
          <ion-text>{{"PUZZLE.solution_word_dialog.saying_intro" | translate }}</ion-text>
        </ion-item>
        <ion-item lines="none">
          <lib-app-puzzle-solution-word-animation class="solution-word" [solutionWord]="saying" [solutionOriginal]="sayingOriginal"></lib-app-puzzle-solution-word-animation>
        </ion-item>
      </ion-list>
    </ion-row>
    <ion-row>
      <div class="puzzle-modal-buttons">
        <ion-button color="primary" (click)="closeDialog(false)" fill="solid">
          <span>{{"PUZZLE.solution_word_dialog.buttons.back_to_game" | translate }}</span>
          <ion-icon slot="start" name="backspace-sharp"></ion-icon>
        </ion-button>
        <ion-button color="primary" (click)="closeDialog(true)" fill="solid" *ngIf="sweepstake && !isSayingDialog"
                    [disabled]="winType === 'full-puzzle'">
          <span>{{"PUZZLE.solution_word_dialog.buttons.sweepstake" | translate }}</span>
          <ion-icon slot="end" name="send-sharp"></ion-icon>
        </ion-button>
      </div>
    </ion-row>
  </ion-grid>
</ion-content>
